import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexBetween } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd } from '../../Zemplin/General/Table';
import {
  getInvoiceDetailInfo,
  getOrderRowInfo,
} from '../../../utilities/selectors';
import { formatDate, formatPrice, getOrderColor } from '../../../utilities';
import { IconImg } from '../../..';

export interface Props {
  order?: any;
  theme: any;
  status: boolean;
  downloadFile: any;
  currency: string;
}

function InvoiceRow({ order, theme, status, downloadFile, currency }: Props) {
  // const { id, date, status, sumPrice, ordernr } = getOrderRowInfo(order);
  // const color = getOrderColor(status, theme);

  if (!order) {
    return null;
  }

  const handleDownloadFile = () => {
    downloadFile(order);
  };

  const type = order['@_InvCus_Type'];
  return (
    <StyledTableRow>
      <StyledTableTd>
        <StatusText>
          {type === 73
            ? __(`Faktúra`)
            : type === 67
            ? __('Dobropis')
            : __('Predfaktúra')}
        </StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText>{order['@_InvCus_Code']}</StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText>
          {formatDate(order['@_InvCus_DateAcc'], 'DD-MM-YYYY')}
        </StatusText>
      </StyledTableTd>
      <StyledTableTd>
        {' '}
        <StatusText>
          {formatDate(order['@_InvCus_DateDue'], 'DD-MM-YYYY')}
        </StatusText>
      </StyledTableTd>
      <StyledTableTd>
        {' '}
        <StyledStatusText status={status}>{`${
          status ? __('Uhradená') : __('Neuhradená')
        }`}</StyledStatusText>
      </StyledTableTd>
      {order.link && (
        <StyledTableTdCenter>
          {' '}
          <StyledButton
            onClick={handleDownloadFile}
            // align={'center'}
            // href={`${process.env.REACT_APP_API_BASE_URL}${order.link}`}
            // target="_blank"
          >
            <IconImg
              cursor={'pointer'}
              width={24}
              height={24}
              src={'/assets/dsi/download.svg'}
            />
          </StyledButton>
        </StyledTableTdCenter>
      )}
      <StyledTableTd>
        <StatusText align={'right'}>
          {formatPrice(order['@_InvCus_ValCur'], currency)}
        </StatusText>
      </StyledTableTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)<{ align: boolean }>`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const StyledTableTdCenter = styled(StyledTableTd)`
  text-align: center;
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.white};
  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const StatusText = styled(TextP)<{ align?: string }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 400;
  text-align: ${({ align }) => (align ? align : 'left')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledStatusText = styled(StatusText)<{ status?: boolean }>`
  color: ${({ theme, status }) =>
    status ? theme.colors.successColor : theme.colors.dangerColor};
  font-weight: 500;
`;

const StyledButton = styled.button`
  border: 0;
  background: transparent;
`;

const WithThemeRow: any = withTheme(InvoiceRow);
export { WithThemeRow as DsiInvoiceRow };
